'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Div with max-width and margin auto for centering content
 */

var Container = function Container(_ref, _ref2) {
  var props = _objectWithoutProperties(_ref, []);

  var rebass = _ref2.rebass;

  var _config$rebass = _extends({}, _config2.default, rebass);

  var scale = _config$rebass.scale;


  return _react2.default.createElement(_Base2.default, _extends({}, props, {
    className: 'Container',
    baseStyle: {
      maxWidth: 1024,
      paddingLeft: scale[2],
      paddingRight: scale[2],
      margin: 'auto'
    } }));
};

Container.contextTypes = {
  rebass: _react2.default.PropTypes.object
};

exports.default = Container;


/*****************
 ** WEBPACK FOOTER
 ** ./~/rebass/dist/Container.js
 ** module id = 197
 ** module chunks = 0
 **/